import React, { useState } from "react";
import { Icon } from "../Icon";
// import ReactTooltip from "react-tooltip";

export function YearHeaderInput(props) {
  const {
    update, //Function to update date.yearSTD
    year,
    tooltipID,
  } = props;

  // console.log('Setting Year', year);
  //Initialize State year
  const [displayYear, setDisplayYear] = useState(year);

  const handleYearChange = (ev) => {
    const { value } = ev.target;
    // console.log('Input Change', value);
    const yearNum = parseInt(value, 10);
    setDisplayYear(value);
    if (!Number.isNaN(yearNum)) {
      // setDisplayYear(value);
      update({ year: yearNum });
    } else {
      //...handle error?
      // setDisplayYear(value);
    }
  };

  const handleYearNext = (ev) => {
    ev.preventDefault();
    const yearNum = parseInt(displayYear, 10);
    if (!Number.isNaN(yearNum)) {
      setDisplayYear(yearNum + 1);
      if (update) update({ year: yearNum + 1 });
    }
  };

  const handleYearPrev = (ev) => {
    ev.preventDefault();
    const yearNum = parseInt(displayYear, 10);
    if (!Number.isNaN(yearNum)) {
      setDisplayYear(yearNum - 1);
      if (update) update({ year: yearNum - 1 });
    }
  };

  // ReactTooltip.rebuild();

  return (
    <div className="chronos-calendar-date-picker-year-header">
      <span
        className="chronos-calendar-dropdown-nav-btn"
        onClick={handleYearPrev}
      >
        <Icon icon="far fa-chevron-left" />
      </span>
      <div
        className="chronos-calendar-dropdown-year"
        data-for={tooltipID}
        data-tip="Click to edit"
      >
        <input type="text" value={displayYear} onChange={handleYearChange} />
      </div>
      <span
        className="chronos-calendar-dropdown-nav-btn"
        onClick={handleYearNext}
      >
        <Icon icon="far fa-chevron-right" />
      </span>
    </div>
  );
}

// function parseYear(yearStr, calendar) {
//   let checkYear = parseInt(yearStr, 10);
//   if (Number.isNaN(checkYear)) {
//     return null;
//   }
//   return { year: checkYear };
//   const isNegative = bigInt(yearStr).lt('0');
//   let yearInSeconds = bigInt(yearStr).abs().times(calendar.time.year.duration);
//   let ret = {};
//   // console.log('Starting parse. YearInSeconds ', yearInSeconds);
//   for (let u = 0; u < condensedYearUnits.length; u++) {
//     const unit = condensedYearUnits[u];
//     const unitDuration = calendar.time[unit].duration;
//     // console.log('Processing Unit', unit, unitDuration);
//     if (bigInt(yearInSeconds).greaterOrEquals(unitDuration)) {
//       // console.log(
//       //   'Seconds:',
//       //   yearInSeconds.toString(),
//       //   ' greater than ',
//       //   unitDuration
//       // );
//       let unitCount = bigInt(yearInSeconds).divide(unitDuration);
//       // console.log(
//       //   'There are ',
//       //   unitCount.toString(),
//       //   ' ',
//       //   unit,
//       //   's in the value'
//       // );
//       if (isNegative) {
//         const negativeUnits = [
//           'aeon',
//           'epoch',
//           'myriad',
//           'millenium',
//           'century',
//           'decade',
//           'year',
//         ];
//         if (negativeUnits.indexOf(unit) > -1) {
//           unitCount = bigInt(unitCount).times('-1');
//           // console.log('Unitcount to neg: ', unitCount);
//         }
//       }
//       ret[unit] = unitCount.toString();
//       const unitCountDuration = bigInt(unitCount.abs()).times(unitDuration);
//       // console.log(
//       //   unitCount.toString(),
//       //   unit,
//       //   's is ',
//       //   unitCountDuration.toString()
//       // );
//       yearInSeconds = bigInt(yearInSeconds).minus(unitCountDuration);
//       // console.log('New Year in Seconds', yearInSeconds);
//     } else {
//       // console.log(unit, yearInSeconds);
//       ret[unit] = '0';
//     }
//   }
//   //Calculate new yearSTD
//   // ret.yearSTD = yearStr;
//   if (isNegative) {
//     // ret.year = bigInt(`${ret.year}`).times('-1').toString();
//   }
//   // console.log('Remainder', yearInSeconds, ret);
//   return ret;
// }
